import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_SERVICE_RESET = 'DELETE_SERVICE_RESET';
export const DELETE_SERVICE_LOADING = 'DELETE_SERVICE_LOADING';
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS';
export const DELETE_SERVICE_REJECT = 'DELETE_SERVICE_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteServiceReset = () => ({ type: DELETE_SERVICE_RESET });
export const deleteServiceLoading = () => ({ type: DELETE_SERVICE_LOADING });
export const deleteServiceSuccess = (payload) => ({ type: DELETE_SERVICE_SUCCESS, payload });
export const deleteServiceReject = (payload) => ({ type: DELETE_SERVICE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteServiceRequest = async (getState, id) => {
    const options = await withToken({
        method: Methods.DELETE
    }, getState);
    return request(`/Clients/web/DeleteServicesClients?id=${id}`, options);
};